export default class Notable {
	note: string;
}
